import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FcLikePlaceholder } from "react-icons/fc";
import messageImg from "../assets/message.png";
import leetcode from "../assets/leetcode.png";


import { faInstagram, faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';
// import { faPhoneVolume } from '@fortawesome/free-solid-svg-icons';




export const Contact = () => {
  return (
    <section id="contact-section" className='contact-section'>
        <Container>
                <h1 className='header-skillset contact-line' style={{textAlign:'center'}}>
                    Uncovering Opportunities Together - Your Message Can Open Doors!
                    <img src = {messageImg} alt= "Location" 
                        style={{paddingLeft: '5px', width: '1.5em', height: '1.5em', verticalAlign: 'middle' }}/>
                </h1>

                <div className="icon-container">
                    <a href="mailto:jaideep.nuvvula@gmail.com" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faEnvelope} className="social-icon icon-envelope" />
                    </a>
                    <a href="https://www.instagram.com/jaideepnuvvula/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faInstagram} className="social-icon icon-instagram" />
                    </a>
                    <a href="https://github.com/jnuvvula9" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faGithub} className="social-icon icon-github" />
                    </a>
                    <a href="https://www.linkedin.com/in/jaideep-nuvvula/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faLinkedin} className="social-icon icon-linkedin" />
                    </a>
                    <a href="https://leetcode.com/nuvvula/" target="_blank">
                      <img src = {leetcode} alt="Leetcode" style={{width: '2.5em', height: '2.5em' , verticalAlign: 'middle'}} />
                    </a>

                </div>
        </Container>

    </section>

  )
}
